import { fetcher } from '@commenda/utils';

export type TUnassignCompanyHandler = {
  companyId: number;
  handlerId: string;
};

export async function unassignCompanyHandler(
  data: TUnassignCompanyHandler
): Promise<Response> {
  try {
    const res = await fetcher(
      `company/${data.companyId}/handler/${data.handlerId}`,
      {
        method: 'DELETE',
      }
    );
    return res;
  } catch (err) {
    console.error(err);
  }
}
